export default __webpack_public_path__ + "static/media/0059.5cfbea0c.png";